import classNames from 'classnames/bind';
import AirlineLogo from 'common/airlineLogo';
import { usePriceTransparency } from 'contexts/priceTransparency';
import styles from '../index.module.scss';

const cx = classNames.bind(styles);

interface RouteInfoWithLogoProps {
  routeIndex: number;
}

const RouteInfoWithLogo = ({ routeIndex }: RouteInfoWithLogoProps) => {
  const { airports, selectedScheduleDetails } = usePriceTransparency();
  return (
    <b className={cx('route')}>
      <AirlineLogo
        airlineCode={selectedScheduleDetails?.[routeIndex]?.['av']}
        alt={`airline_logo_${selectedScheduleDetails?.[routeIndex]?.['av']}`}
        className={cx('airline_logo')}
      />
      {`${selectedScheduleDetails?.[routeIndex]?.['av']}${selectedScheduleDetails?.[routeIndex]?.['fn']}`}{' '}
      {airports[selectedScheduleDetails?.[routeIndex]?.['sa']]}
      {' - '}
      {airports[selectedScheduleDetails?.[routeIndex]?.['ea']]}
    </b>
  );
};

export default RouteInfoWithLogo;
